module.exports = __webpack_public_path__ + "static/media/advisory_male.2fa95910.svg";